import { AbstractControl, FormGroup, FormControl } from '@angular/forms';

export namespace FormUtils {
  export namespace Patterns {
    export const EMAIL = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;
    export const PHONE_NUMBER = /^0[0-9]{9}$/;
  }

  export namespace Validators {
    export function select(control: FormControl): { required: boolean } {
      const { value } = control;
      return +value === 0 ? { required: true } : null;
    }
    export function checkBox(control: FormControl): { required: boolean } {
      const { value } = control;
      return value ? null : { required: true };
    }
  }

  export function touchControls(controls: { [key: string]: AbstractControl }): void {
    for (const key in controls) {
      if (!controls.hasOwnProperty(key)) {
        continue;
      }

      controls[key].markAsTouched();
      controls[key].markAsDirty();

      const formGroup = controls[key] as FormGroup;
      if (formGroup.controls) {
        touchControls(formGroup.controls);
      }
    }
  }

  export function getControl(controlKey: string, form: FormGroup): AbstractControl {
    return form.get(controlKey);
  }

  export function getValue(controlKey: string, form: FormGroup): any {
    return form.get(controlKey).value;
  }

  export function hasError(controlKey: string, errorCode: string, form: FormGroup): boolean {
    return form.get(controlKey).hasError(errorCode);
  }

  export function isDirty(controlKey: string, form: FormGroup): boolean {
    return form.get(controlKey).dirty;
  }

  export function isTouched(controlKey: string, form: FormGroup): boolean {
    return form.get(controlKey).touched;
  }

  export function isTouchedAndDirty(controlKey: string, form: FormGroup): boolean {
    return isTouched(controlKey, form) && isDirty(controlKey, form);
  }
}
